import { ERROR_MESSAGES } from 'ha/modules/PhoneValidation/constants';

export const UPDATE_PHONE_NUMBER = 'ACTIVATIONMODAL/UPDATE_PHONE_NUMBER';
export const UPDATE_PHONE_NUMBER_SUCCESS =
  'ACTIVATIONMODAL/UPDATE_PHONE_NUMBER_SUCCESS';
export const UPDATE_PHONE_NUMBER_ERROR =
  'ACTIVATIONMODAL/UPDATE_PHONE_NUMBER_ERROR';

const updatePhoneNumberStart = () => ({
  type: UPDATE_PHONE_NUMBER,
});

const updatePhoneNumberSuccess = payload => ({
  type: UPDATE_PHONE_NUMBER_SUCCESS,
  payload,
});

const updatePhoneNumberError = error => ({
  type: UPDATE_PHONE_NUMBER_ERROR,
  payload: new Error(error),
  error: true,
});

export default function setPhoneNumber(userID, { phone, code }) {
  return (dispatch, _, { apiV2 }) => {
    dispatch(updatePhoneNumberStart());

    return apiV2
      .updateUser(userID, {
        phone,
        phoneCountryCode: code,
      })
      .then(
        ({ data }) => dispatch(updatePhoneNumberSuccess(data)),
        () => dispatch(updatePhoneNumberError(ERROR_MESSAGES.SERVER_ERROR)),
      );
  };
}
